/**
 * Müslinevi sepet önerisi (seccade): desen seçilir, "Ekle" ile sepete eklenir.
 * Ekleme akışı muslinevi-qty-tiers.js ile aynı (Horizon CartLinesUpdateEvent → sepet yeniden çizilir).
 */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

class MuslineviCartOneri extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    this.addEventListener('change', (e) => {
      const sel = e.target;
      if (!(sel instanceof HTMLSelectElement) || !('oneriVariant' in sel.dataset)) return;
      const src = sel.selectedOptions[0]?.dataset.img;
      const img = sel.closest('.m-oneri__item')?.querySelector('[data-oneri-img]');
      const url = sel.selectedOptions[0]?.dataset.url;
      if (url) sel.closest('.m-oneri__item')?.querySelectorAll('[data-oneri-link]').forEach((a) => a.setAttribute('href', url));
      if (src && img) {
        img.removeAttribute('srcset');
        img.src = src;
      }
    });
    this.addEventListener('click', (e) => {
      const btn = e.target instanceof Element ? e.target.closest('[data-oneri-add]') : null;
      if (!btn || btn.disabled) return;
      const id = btn.closest('.m-oneri__item')?.querySelector('[data-oneri-variant]')?.value;
      if (id) this.#add(btn, Number(id));
    });
  }

  async #add(btn, id) {
    btn.disabled = true;
    btn.textContent = '…';
    const sectionIds = [];
    for (const el of document.querySelectorAll('cart-items-component')) {
      if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    }
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: String(id), quantity: 1 }],
        promise: deferred.promise,
      })
    );
    const baseDetail = { source: 'muslinevi-cart-oneri', sourceId: 'muslinevi-cart-oneri', itemCount: 1 };
    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }),
      });
      const response = await res.json();
      const cart = await (await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' } })).json();
      if (response.status) {
        this.dispatchEvent(new CartErrorEvent({ error: response.message || 'Add to cart failed', code: 'INVALID' }));
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { ...baseDetail, items: cart.items, didError: true },
        });
        btn.disabled = false;
        btn.textContent = 'Ekle';
        return;
      }
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { ...baseDetail, items: cart.items, sections: response.sections, didError: false },
      });
      document.dispatchEvent(new CustomEvent('muslinevi:cart-changed'));
    } catch (err) {
      console.error(err);
      deferred.reject(err);
      btn.disabled = false;
      btn.textContent = 'Ekle';
    }
  }
}

if (!customElements.get('muslinevi-cart-oneri')) customElements.define('muslinevi-cart-oneri', MuslineviCartOneri);

// 26 Eki: sepet güncellenince (ürün eklendi/silindi) çekmece yeniden çizilir ama kaydırma konumu altta kalabiliyor;
// müşteri yalnız kargo/toplam ve önerileri görüp "sepette ürün yok" sanıyordu. Her güncellemede en üste dön.
if (!window.__mCartTop) {
  window.__mCartTop = true;
  const top = () =>
    document.querySelectorAll('.cart-drawer__content, .cart-drawer__items').forEach((el) => {
      el.scrollTop = 0;
    });
  // Yeniden çizim, ekleme isteği bittikten sonra gelir; iki kez dene
  const toTop = () => [400, 1200].forEach((ms) => setTimeout(top, ms));
  for (const ev of ['shopify:cart:lines-update', 'shopify:cart:view', 'muslinevi:cart-changed']) document.addEventListener(ev, toTop);
}
